/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { Redirect } from 'react-router-dom'
import { get } from 'lodash'
/**
 *     Import
 *     - Components
 */
import Container from '../../../common/Container/Container'
import HeaderContainer from '../../../common/HeaderContainer/HeaderContainer'
import Accordion from '../../../common/Accordion/Accordion'
import Loading from '../../../common/Loading/Loading'
import { Button } from '../../../common/Button/Button'
import DatePicker from '../../../common/DatePicker/DatePicker'

import Step02 from './containers/Step02'
import Step02cp from './containers/Step02cp'
import Step03 from '../../../../containers/pages/Quote/Step03'
// import Step03c from '../../../../containers/pages/Quote/Step03c'
import Step03c from './containers/Step03c'
import Step03m from './containers/Step03m'
import Step03w from './containers/Step03w'
import Step03d from '../../../../containers/pages/Quote/Step03d'
import Step04 from '../../../../containers/pages/Quote/Step04'
// import Step04 from './containers/Step04'
// import Step04c from '../../../../containers/pages/Quote/Step04c'
import Step04c from './containers/Step04c'
import Step04m from './containers/Step04m'
import Step04d from './containers/Step04d'
import Other from './components/Other'
import CoverOptions from './containers/CoverOptions'
import PopUp from '../../../common/PopUp/PopUp'

/**
 *     Import
 *     - CSS
 */
import './styles/mta.css'
let checkStep: any = {
    loading: false,
    done: true,
    error: null,
    response: [],
}
export default class MTA extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            date: new Date(),
            accordions: {
                accor01: false,
                accor02: false,
                accor03: false,
                accor04: false,
                accor05: false,
            },
            effectiveDate: null, // this.getFormattedDateOutput(new Date()),
            expiryDate: this.getFormattedDateOutput(new Date(new Date().setFullYear(new Date().getFullYear() + 1))),
            other: '',
            riskLocations: {
                loading: false,
                done: true,
                error: null,
                response: [],
            },
            additionalCover: {},
            stockBusinessAssets: {},
            totalExhibitsSumInsured: 0,
            incomingExhibitionLimit: 0,
            outgoingExhibitionLimit: 0,
            coverOptions: {},
            modified: false,
            disableMTA: true,
            dateIsCheck: true,
            checkCollections: false,
            checkAssets: false,
        }
    }

    componentDidMount() {
        this.props.getPolicyMTA(this.props.match.params.id)
    }

    componentWillUpdate(nextProps: any, nextState: any) {
        if (nextProps.policy.response.riskLocations !== this.state.riskLocations.response
            && Object.keys(nextProps.policy.response).length !== 0) {
            var ch = {
                step: null,
                isCollectors: nextProps.policy.response.isCollectors,
                isMuseums: nextProps.policy.response.isMuseums,
                isDealersStock: nextProps.policy.response.isDealersStock,
                isWineSpirits: nextProps.policy.response.isWineSpirits,
                isCommercialProperty: nextProps.policy.response.isCommercialProperty,
                policy_type_id: nextProps.policy.response.id,
            }
            checkStep = { ...checkStep, response: ch }
        }
    }

    componentWillReceiveProps(nextProps: any) {
        if (Object.keys(nextProps.policy.response).length !== 0) {

            let resp = nextProps.policy.response

            this.setState({
                ...this.state,
                additionalCover: resp.additionalCover,
                stockBusinessAssets: resp.stockBusinessAssets,
                totalExhibitsSumInsured: get(resp, 'stockBusinessAssets.totalExhibitsSumInsured', 0),
                incomingExhibitionLimit: get(resp, 'stockBusinessAssets.incomingExhibitionLimit', 0),
                outgoingExhibitionLimit: get(resp, 'stockBusinessAssets.outgoingExhibitionLimit', 0),
                coverOptions: resp.quoteVariation,
            })

            const updatedLocations = resp.riskLocations.map((location, index) => ({
                ...location,
                temp_id: index + 1,
                initial_address: true,
            }))

            this.setState({
                riskLocations: {
                    ...this.state.riskLocations,
                    response: updatedLocations,
                },
            })
        }
    }

    // componentDidUpdate(prevProps: any) {
    //     if (
    //         prevProps.policy.response.riskLocations !== this.props.policy.response.riskLocations &&
    //         Object.keys(this.props.policy.response).length !== 0
    //     ) {
    //         const updatedLocations = this.props.policy.response.riskLocations.map((location, index) => ({
    //             ...location,
    //             temp_id: index + 1,
    //             initial_address: true,
    //         }))

    //         this.setState({
    //             riskLocations: {
    //                 ...this.state.riskLocations,
    //                 response: updatedLocations,
    //             },
    //         })
    //     }
    // }

    /**
     * Will format the date output
     *
     * @param {*} date
     * @returns the date output to show
     * @memberof DatePicker
     */
    getFormattedDateOutput = (date: any) => {
        let newDate = new Date(date)

        let year = newDate.getFullYear().toString().substr(-2)
        // tslint:disable-next-line
        return `${('0' + newDate.getDate()).slice(-2)}-${('0' + (newDate.getMonth() + 1)).slice(-2)}-${year}`
    }

    handleCancel = () => {
        this.props.history.goBack()
    }

    handleConfirm = () => {
        /* tslint:disable */
        let body = this.state


        delete body.accordions
        delete body.date
        delete body.modified
        delete body.disableMTA
        delete body.dateIsCheck
        delete body.checkCollections
        delete body.checkAssets

        body.riskLocations = body.riskLocations.response

        // console.log(body, my)
        this.props.addMTA(this.props.match.params.id, body)
        /* tslint:enable */
    }

    /**
     * Handle Submit actions to save the data on the State
     */
    handleOtherSubmit = (data: any) => {
        this.setState({ other: data, modified: true })
    }

    stockBusinessAssetsSubmit = (data: any) => {
        let { response } = this.props.policy
        this.setState({
            stockBusinessAssets: data.quote.stockBusinessAssets,
            modified: true,
            checkCollections: (this.state.riskLocations.response.length === 1) ? false : true,
            checkAssets: true,
        })

        if (response.isMuseums) {
            this.setState({
                totalExhibitsSumInsured: get(data.quote, 'totalExhibitsSumInsured', 0),
                incomingExhibitionLimit: get(data.quote, 'incomingExhibitionLimit', 0),
                outgoingExhibitionLimit: get(data.quote, 'outgoingExhibitionLimit', 0),
            })
        }

        if (response.isCollectors || response.isMuseums || response.isDealersStock || response.isWineSpirits) {
            this.setState({
                disableMTA: (this.state.riskLocations.response.length === 1 && !this.state.dateIsCheck) ? false : true,
            })
        } else {
            this.setState({
                disableMTA: (this.state.effectiveDate !== null) ? false : true,
            })
        }
    }

    additionalCoverSubmit = (data: any) => {
        this.setState({ additionalCover: data.quote.additionalCover, modified: true, checkCollections: false })
        if (this.state.effectiveDate !== null) {
            this.setState({ disableMTA: false, dateIsCheck: false })
        }
    }

    coverOptionsSubmit = (data: any) => {
        this.setState({ coverOptions: data, modified: true })
    }

    /**
     * Handle the Accordion toggle
     */
    handleAccordion = (name: string) => {
        this.setState({
            ...this.state,
            accordions: { ...this.state.accordions, [name]: !this.state.accordions[name] },
        })
    }

    /**
     * Placeholder update function
     */
    updateData = (data: any) => {
        this.setState({ modified: true })
    }

    /**
     * Locations handlers
     */
    addLocations = (id: any, data: any) => {
        data.riskLocation.id = null
        const newLocation = {
            ...data.riskLocation,
            temp_id: Date.now(),
        }
        const arr = this.state.riskLocations.response

        arr.push(newLocation)

        this.setState({
            riskLocations: { ...this.state.riskLocations, response: arr },
            modified: true, disableMTA: false, checkCollections: true,
        })
    }

    addLocationsSecurity = (quoteId: any, tempId: any, body: any) => {
        const { isCommercialProperty = false } = this.props
        if (isCommercialProperty) {
            const arr = this.state.riskLocations.response
            const index = arr.findIndex(location => location.temp_id === tempId)

            if (index > -1) {
                const updatedLocations = [...arr]
                updatedLocations[index] = {
                    ...updatedLocations[index],
                    ...body.riskLocation,
                }

                this.setState({
                    riskLocations: { ...this.state.riskLocations, response: updatedLocations },
                })
            }
        }
        return true
    }

    deleteLocation = (id: any, locationId: any) => {
        let arr = this.state.riskLocations.response
        const index = arr.findIndex(location => location.temp_id === id)

        if (index > -1) {
            arr.splice(index, 1)
            this.setState({
                riskLocations: { ...this.state.riskLocations, response: arr },
                modified: true,
                disableMTA: false,
                checkCollections: true,
            })
        }
    }

    /**
     * Calendar onChange functions
     */
    expiryDateChange = (data: any) => {
        this.setState({ expiryDate: data })
    }

    effectiveDateChange = (data: any) => {
        let { response } = this.props.policy
        this.setState({ effectiveDate: data, dateIsCheck: false })
        if ((response.isCollectors || response.isMuseums || response.isDealersStock || response.isWineSpirits) &&
            this.state.checkCollections !== true) {
            this.setState({ disableMTA: false })
        }

        if (!response.isCollectors && !response.isMuseums && !response.isDealersStock && !response.isWineSpirits) {
            this.setState({ disableMTA: false })
        }
    }

    /**
     * On focus set Label element with class 'active'
     */
    focusChange = (event: any) => {
        if (event.target.classList.contains('calendar__input')) {
            event.target.parentNode.parentNode.previousSibling.classList = 'active'
        } else {
            event.target.previousSibling.classList = 'active'
        }
    }

    getSectionTitle = () => {
        const { isCollectors, isMuseums, isDealersStock, isWineSpirits, isCommercialProperty } = this.props

        if (isCollectors) {
            return 'Collections Policy'
        } else if (isMuseums) {
            return 'Museums Policy'
        } else if (isDealersStock) {
            return 'Dealers Stock'
        } else if (isWineSpirits) {
            return 'Wine & Spirits Policy'
        } else if (isCommercialProperty) {
            return 'Property Owners Policy'
        } else {
            return 'Commercial Art Insurance'
        }
    }

    render() {
        const { isCollectors, isMuseums, isDealersStock, isWineSpirits, isWineSpiritsSteve, mta_add } = this.props
        let { response, loading, done } = this.props.policy
        const { effectiveDate } = this.state
        // let risklocation3: any = this.state.riskLocations
        // if (this.state.riskLocations.response.length > 3) {
        //     risklocation3.response.length = 3
        // }
        if (this.props.policySubmit) {
            return (<Redirect to={`${this.props.match.params.id}/summary/${this.props.policySubmit.mtaId}`} />)
        }
        if (loading && (isCollectors === '' || isMuseums === '' || isDealersStock === '' || isWineSpirits === '')) {
            let loadingStyle = {
                position: 'absolute',
                top: '50%',
                left: '50%',
            }
            return (<div><Loading style={loadingStyle} /></div>)
        }
        return (
            <div className="mta">
                {
                    (get(mta_add, 'loading', false)) ?
                        <PopUp
                            title="MTA Loading"
                            action={() => { '' }}
                        >
                            ...loading
                        </PopUp> : null
                }
                <HeaderContainer
                    className="mta__header"
                    fullwidth={false}
                    pretitle={this.getSectionTitle()}
                    titles={['Add Mid Term Adjustment']}
                />

                <Container className="quote__edit mta__edit" fullwidth={false}>
                    <div className="quote__edit__infoblock">

                        <div className="mta__calendars">
                            <h3>MTA Date</h3>
                            <div className="quote__form__group quote__form__group--calendar">
                                <label>Effective date</label>
                                <DatePicker
                                    placeholder="Effective date"
                                    onChange={this.effectiveDateChange}
                                    onFocus={this.focusChange}
                                    mtaData={response}
                                    mta={true}
                                />
                            </div>
                            {/* <div className="quote__form__group quote__form__group--calendar">
                                <label>MTA expiry date</label>
                                <DatePicker
                                    placeholder="Set MTA expiry date"
                                    dateSelected={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                                    onChange={this.expiryDateChange}
                                    onFocus={this.focusChange}
                                />
                            </div> */}
                        </div>

                        {(response.isCommercialProperty) ?
                            <Accordion
                                title="Risk Address"
                                onChange={() => this.handleAccordion('accor01')}
                            >
                                {(!loading && done && this.state.riskLocations && this.state.riskLocations.response &&
                                    this.state.riskLocations.response.length !== 0) ? (
                                    <Step02cp
                                        editQuote={true}
                                        mta={true}
                                        updateData={this.updateData}
                                        match={this.props.match}
                                        riskLocations={this.state.riskLocations}
                                        addLocations={this.addLocations}
                                        addLocationsSecurity={this.addLocationsSecurity}
                                        deleteLocation={this.deleteLocation}
                                        checkStep={checkStep}
                                        isCollectors={response.isCollectors}
                                        isMuseums={response.isMuseums}
                                        isDealersStock={response.isDealersStock}
                                        isWineSpirits={response.isWineSpirits}
                                        isCommercialProperty={response.isCommercialProperty}
                                    />
                                ) : <Loading />}
                            </Accordion> :
                            <Accordion
                                title="Risk Address"
                                onChange={() => this.handleAccordion('accor01')}
                            >
                                {(!loading && done && this.state.riskLocations.response.length !== 0) ? (
                                    <Step02
                                        editQuote={true}
                                        mta={true}
                                        updateData={this.updateData}
                                        match={this.props.match}
                                        riskLocations={this.state.riskLocations}
                                        addLocations={this.addLocations}
                                        addLocationsSecurity={this.addLocationsSecurity}
                                        deleteLocation={this.deleteLocation}
                                        checkStep={checkStep}
                                        isCollectors={response.isCollectors}
                                        isMuseums={response.isMuseums}
                                        isDealersStock={response.isDealersStock}
                                        isWineSpirits={response.isWineSpirits}
                                    />
                                ) : <Loading />}
                            </Accordion>}

                        {!response.isCommercialProperty && (<div>

                            {(response.isCollectors) ?
                                <Accordion
                                    title="Collection Assets"
                                    onChange={() => this.handleAccordion('accor02')}
                                >
                                    {(!loading && done) ? (
                                        <Step03c
                                            data={response.stockBusinessAssets}
                                            // values={response.stockBusinessAssets}
                                            fullQuote={this.props.policy}
                                            editQuote={true}
                                            mta={true}
                                            updateData={this.stockBusinessAssetsSubmit}
                                            match={this.props.match}
                                            disableMta={false}
                                        />
                                    ) : <Loading />}
                                </Accordion>
                                : isMuseums ? <Accordion
                                    title="Museums Assets"
                                    onChange={() => this.handleAccordion('accor02')}
                                >
                                    {(!loading && done) ? (
                                        <Step03m
                                            data={response.stockBusinessAssets}
                                            // values={response.stockBusinessAssets}
                                            fullQuote={this.props.policy}
                                            editQuote={true}
                                            mta={true}
                                            updateData={this.stockBusinessAssetsSubmit}
                                            match={this.props.match}
                                            disableMta={false}
                                        />
                                    ) : <Loading />}
                                </Accordion> : isDealersStock ? <Accordion
                                    title="Dealers Stock Assets"
                                    onChange={() => this.handleAccordion('accor02')}
                                >
                                    {(!loading && done) ? (
                                        <Step03d
                                            data={response.stockBusinessAssets}
                                            // values={response.stockBusinessAssets}
                                            fullQuote={this.props.policy}
                                            editQuote={true}
                                            mta={true}
                                            updateData={this.stockBusinessAssetsSubmit}
                                            match={this.props.match}
                                            disableMta={false}
                                        />
                                    ) : <Loading />}
                                </Accordion> :
                                    isWineSpirits ? <Accordion
                                        title="Wine & Spirits Assets"
                                        onChange={() => this.handleAccordion('accor02')}
                                    >
                                        {(!loading && done) ? (
                                            <Step03w
                                                data={response.stockBusinessAssets}
                                                // values={response.stockBusinessAssets}
                                                fullQuote={this.props.policy}
                                                editQuote={true}
                                                mta={true}
                                                updateData={this.stockBusinessAssetsSubmit}
                                                match={this.props.match}
                                                disableMta={false}
                                                isWineSpiritsSteve={isWineSpiritsSteve}
                                            />
                                        ) : <Loading />}
                                    </Accordion> :
                                        <Accordion
                                            title="Add Stock & Business Assets"
                                            onChange={() => this.handleAccordion('accor02')}
                                        >
                                            {(!loading && done) ? (
                                                <Step03
                                                    data={response.stockBusinessAssets}
                                                    editQuote={true}
                                                    mta={true}
                                                    updateData={this.stockBusinessAssetsSubmit}
                                                    match={this.props.match}
                                                />
                                            ) : <Loading />}
                                        </Accordion>}

                            <Accordion
                                title={(response.isCollectors) ? 'Collections Locations' : isMuseums ?
                                    'Museums Locations' : isDealersStock ? 'Dealers stock Locations' :
                                        response.isWineSpirits ? 'Wine & Spirits Locations' : 'Additional Cover'}
                                onChange={() => this.handleAccordion('accor03')}
                            >
                                {(!loading && done) ? (
                                    (response.isCollectors || response.isWineSpirits) ?
                                        <Step04c
                                            data={this.state.stockBusinessAssets}
                                            riskLocations={this.state.riskLocations}
                                            editQuote={true}
                                            mta={true}
                                            updateData={this.additionalCoverSubmit}
                                            match={this.props.match}
                                            countries={this.props.countries}
                                            checkAssets={this.state.checkAssets}
                                            isCollectors={isCollectors}
                                        /> : isMuseums ? <Step04m
                                            data={this.state.stockBusinessAssets}
                                            riskLocations={this.state.riskLocations}
                                            editQuote={true}
                                            mta={true}
                                            updateData={this.additionalCoverSubmit}
                                            match={this.props.match}
                                            countries={this.props.countries}
                                            checkAssets={this.state.checkAssets}
                                            totalExhibitsSumInsured={this.state.totalExhibitsSumInsured}
                                        /> : isDealersStock ? <Step04d
                                            data={this.state.stockBusinessAssets}
                                            riskLocations={this.state.riskLocations}
                                            editQuote={true}
                                            mta={true}
                                            updateData={this.additionalCoverSubmit}
                                            match={this.props.match}
                                            countries={this.props.countries}
                                            checkAssets={this.state.checkAssets}
                                        /> : <Step04
                                            data={response.additionalCover}
                                            editQuote={true}
                                            mta={true}
                                            updateData={this.additionalCoverSubmit}
                                            match={this.props.match}
                                        />
                                ) : <Loading />}
                            </Accordion>
                        </div>
                        )}

                        {(response.isCommercialProperty && response.quoteType && response.quoteType === 'hcc') ?
                            null :
                            (
                                <Accordion
                                    title="Cover Options"
                                    onChange={() => this.handleAccordion('accor04')}
                                >
                                    {(!loading && done) ? (
                                        <CoverOptions
                                            updateData={this.coverOptionsSubmit}
                                            isCollectors={response.isCollectors}
                                            isMuseums={response.isMuseums}
                                            isDealersStock={response.isDealersStock}
                                            isWineSpirits={response.isWineSpirits}
                                            isCommercialProperty={response.isCommercialProperty}
                                            quoteType={response.quoteType}
                                            data={response.coverOptions}
                                        />
                                    ) : <Loading />}
                                </Accordion>
                            )}

                        <Accordion
                            title="Other"
                            onChange={() => this.handleAccordion('accor05')}
                        >
                            {(!loading && done) ? (
                                <Other updateData={this.handleOtherSubmit} />
                            ) : <Loading />}
                        </Accordion>

                    </div>
                    <div className="mta__actions padding_b_50">
                        <Button
                            className={`mta__actions__button`}
                            onClick={this.handleCancel}
                        >
                            Cancel
                        </Button>

                        <Button
                            className={`mta__actions__button mta__actions__button--confirm`}
                            disabled={this.state.disableMTA ? true : effectiveDate ? false : true}
                            onClick={this.handleConfirm}
                        >
                            Calculate MTA
                        </Button>

                    </div>
                </Container>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/MTA.tsx